export const subscriptionType = {
  GET_SUBSCRIPTION_REQUEST: "GET_SUBSCRIPTION_REQUEST",
  GET_SUBSCRIPTION_SUCCESS: "GET_SUBSCRIPTION_SUCCESS",
  GET_SUBSCRIPTION_FAIL: "GET_SUBSCRIPTION_FAIL",
  UPDATE_STATUS_REQUEST: "UPDATE_STATUS_REQUEST",
  UPDATE_STATUS_SUCCESS: "UPDATE_STATUS_SUCCESS",
  UPDATE_STATUS_FAIL: "UPDATE_STATUS_FAIL",
  CREATE_SUBSCRIPTION_REQUEST: "CREATE_SUBSCRIPTION_REQUEST",
  CREATE_SUBSCRIPTION_SUCCESS: "CREATE_SUBSCRIPTION_SUCCESS",
  CREATE_SUBSCRIPTION_FAIL: "CREATE_SUBSCRIPTION_FAIL",
  UPDATE_SUBSCRIPTION_REQUEST: "UPDATE_SUBSCRIPTION_REQUEST",
  UPDATE_SUBSCRIPTION_SUCCESS: "UPDATE_SUBSCRIPTION_SUCCESS",
  UPDATE_SUBSCRIPTION_FAIL: "UPDATE_SUBSCRIPTION_FAIL",
  GET_SINGLE_SUBSCRIPTION_REQUEST: "GET_SINGLE_SUBSCRIPTION_REQUEST",
  GET_SINGLE_SUBSCRIPTION_SUCCESS: "GET_SINGLE_SUBSCRIPTION_SUCCESS",
  GET_SINGLE_SUBSCRIPTION_FAIL: "GET_SINGLE_SUBSCRIPTION_FAIL",
  DELETE_SINGLE_SUBSCRIPTION_REQUEST: "DELETE_SINGLE_SUBSCRIPTION_REQUEST",
  DELETE_SINGLE_SUBSCRIPTION_SUCCESS: "DELETE_SINGLE_SUBSCRIPTION_SUCCESS",
  DELETE_SINGLE_SUBSCRIPTION_FAIL: "DELETE_SINGLE_SUBSCRIPTION_FAIL",
  GET_USER_SUBSCRIPTION_LIST_REQUEST: "GET_USER_SUBSCRIPTION_LIST_REQUEST",
  GET_USER_SUBSCRIPTION_LIST_SUCCESS: "GET_USER_SUBSCRIPTION_LIST_SUCCESS",
  GET_USER_SUBSCRIPTION_LIST_FAIL: "GET_USER_SUBSCRIPTION_LIST_FAIL",
  GET_SUBSCRIPTION_DROPDOWN_REQUEST: "GET_SUBSCRIPTION_DROPDOWN_REQUEST",
  GET_SUBSCRIPTION_DROPDOWN_SUCCESS: "GET_SUBSCRIPTION_DROPDOWN_SUCCESS",
  GET_SUBSCRIPTION_DROPDOWN_FAIL: "GET_SUBSCRIPTION_DROPDOWN_FAIL",
  CHANGE_CUSTOMER_TAB: "CHANGE_CUSTOMER_TAB"
};
